import { Modal } from 'react-bootstrap';

import { Actionable } from 'root/widgets/common-components';

import { MOBILE_PAGE } from 'root/widgets/mrt-search-modal/constants';
import { HeaderProps } from 'root/widgets/mrt-search-modal/types';

const isMobileListPage = (page: string) => page === MOBILE_PAGE.LIST;

const Header = ({ modalTitle, sectionTitle, mobilePage, onBack }: HeaderProps) => (
  <Modal.Header closeButton={!isMobileListPage(mobilePage)} className="mrt-search-modal-header">
    {!isMobileListPage(mobilePage) && <h4 className="modal-title">{modalTitle}</h4>}
    {isMobileListPage(mobilePage) && (
      <Actionable variant="link secondary icon-prefix" onClick={onBack}>
        <i className="pgicon-arrow-left" />
        <span className="header-section-title">{sectionTitle}</span>
      </Actionable>
    )}
  </Modal.Header>
);

Header.displayName = 'Header';

export default Header;
